/**
 * @prettier
 * @flow
 */
import { getLanguage } from 'src/utils/translate/language';

export function formatAsNumberCurrency(number?: ?string): string {
    // TODO: Return maybe type
    if (!number) {
        return '';
    }
    const fractionDigits = number.includes('.') ? 2 : 0;
    return Intl.NumberFormat(getLanguage(), {
        style: 'currency',
        currencyDisplay: 'symbol',
        currency: 'MXN',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })
        .format((number: any)) // TODO: Create a test that verifies that this it is still possible to format strings since flow seems to complain
        .replace(/[A-Z]*\$[A-Z\s]*/, '$'); // Remove MX$ for swedish/english locales
}
